export const MINIMUM_CONTRACT_SALARY_KWZ = 70000;

export const SALARY_ALERT_TOOLTIP = "Salário abaixo do valor mínimo";

export const SALARY_ALERT_DISCLAIMER =
  "O trabalhador possui SALÁRIO EXPRESSO NO CONTRATO abaixo do valor mínimo de 70.000 Kwz.";

/**
 * Accepts either a number (already numeric) or a masked string (e.g. "70.000 Kz").
 * Returns null when value is empty/invalid.
 */
export function parseMonetaryToInt(value) {
  if (value == null) return null;
  if (typeof value === "number" && Number.isFinite(value)) return Math.trunc(value);

  const asString = String(value);
  const digitsOnly = asString.replace(/[^0-9]/g, "");
  if (!digitsOnly) return null;

  const parsed = parseInt(digitsOnly, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

function isTrueLike(value) {
  if (value === true) return true;
  if (value === 1) return true;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true" || normalized === "1" || normalized === "sim" || normalized === "yes") return true;
  }
  return false;
}

export function hasContractSalaryAlert(employeeOrSalaryValue) {
  if (employeeOrSalaryValue == null) return false;

  // Backend-provided flag (preferred when available)
  if (typeof employeeOrSalaryValue === "object" && employeeOrSalaryValue !== null) {
    if (isTrueLike(employeeOrSalaryValue.HasSalaryMinimumAlert)) return true;
    if (isTrueLike(employeeOrSalaryValue.hasSalaryMinimumAlert)) return true;

    // Tolerate older naming if present in some payloads
    if (isTrueLike(employeeOrSalaryValue.SalaryAlertOn)) return true;
    if (isTrueLike(employeeOrSalaryValue.salaryAlertOn)) return true;
  }

  const salaryValue =
    typeof employeeOrSalaryValue === "object" && employeeOrSalaryValue !== null
      ? (employeeOrSalaryValue.salaryStatedInTheContract ??
          employeeOrSalaryValue.salaryStatedInContract ??
          employeeOrSalaryValue.salaryExpressedInContract ??
          employeeOrSalaryValue.salaryExpressedInTheContract)
      : employeeOrSalaryValue;

  const salaryInt = parseMonetaryToInt(salaryValue);
  if (salaryInt == null) return false;
  return salaryInt < MINIMUM_CONTRACT_SALARY_KWZ;
}
